import { render } from "./PaymentsContent.vue?vue&type=template&id=762db24e&ts=true"
import script from "./PaymentsContent.vue?vue&type=script&lang=ts"
export * from "./PaymentsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__